module.exports = __webpack_public_path__ + "images/application/i-warning-yellow-492b45e7.svg";